import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'app/core/app-config/state/models';
import { RestConnectorService } from 'app/core/connector-services/rest-connector-service/rest-connector-service.abstract';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable()
export class LanguageRestConnectorService extends RestConnectorService {

  constructor(private readonly _httpClient: HttpClient, protected readonly _store: Store<AppStateInterface>) {
    super(_store);
  }

  public loadLanguages(): Observable<{[key: string]: string}> {
    return this._httpClient.get<{[key: string]: string}>(
      '/api/available-languages',
      { observe: 'response' },
    )
    .pipe(
      map((httpResponse: HttpResponse<{[key: string]: string}>) => {
        return <{[key: string]: string}>httpResponse.body;
      }),
    );
  }
}
